import { StyleSheet } from 'aphrodite';
import { darkGrayFontColor, backgroundAlt, destructive } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	layout: {
		display: 'flex',
		height: '100%',
		minHeight: 0,
		backgroundColor: backgroundAlt,
		width: '100%',
	},
	contentExtras: {
		flex: 1,
		paddingLeft: 28,
		paddingRight: 28,
	},
	contentLoading: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		paddingTop: 20,
		paddingBottom: 20,
		paddingLeft: 28,
		paddingRight: 28,
		minHeight: 0,
	},
	loadingContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		minHeight: 400,
		gap: 16,
	},
	loadingText: {
		fontSize: 14,
		color: darkGrayFontColor,
		margin: 0,
	},
	errorContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		minHeight: 400,
		gap: 12,
		padding: 32,
		textAlign: 'center',
	},
	errorTitle: {
		fontSize: 20,
		fontWeight: 600,
		color: destructive,
		margin: 0,
	},
	errorMessage: {
		fontSize: 14,
		color: darkGrayFontColor,
		margin: 0,
		maxWidth: 500,
	},
});
